<template>
  <div class="pb9">
    <AppEditUsersDialog></AppEditUsersDialog>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      class="elevation-1"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.email }}</td>
        <td>{{ props.item.roles | filterRoleNames }}</td>
        <td>{{ calculateCommonCoursesCompletionPercent(props.item.courses_completion_percent) }}%</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          <ConfirmationDialog ref="confirm"></ConfirmationDialog>
        </td>
      </template>
    </v-data-table>
    <AddUserButton/>
  </div>
</template>

<script>
  import AddUserButton from '@/components/buttons/AddUserButton'
  import AppEditUsersDialog from '@/components/dialogs/AppEditUsersDialog'
  import resourcesMixins from '@/mixins/Resources'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'

  export default {
    name: 'Users',
    components: { AddUserButton, AppEditUsersDialog, ConfirmationDialog },
    mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'users',
        items: [],
        tableHeaders: [
          { text: 'ID', value: 'id', width: '5%' },
          { text: 'Name', value: 'name', width: '22.5%' },
          { text: 'Email', value: 'email', width: '22.5%' },
          { text: 'Roles', value: 'email', width: '22.5%' },
          { text: 'Courses Complete', value: 'email', width: '5%' },
          { text: 'Actions', value: 'actions', width: '22.5%' }
        ],
        rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
        pagination: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'id'
        }
      }
    },
    methods: {
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      },
      calculateCommonCoursesCompletionPercent (coursesData) {
        let coursesObject = JSON.parse(coursesData)
        let result = 0

        if (coursesObject) {
          let courses = Object.keys(coursesObject)

          let coursesCommonPercents = courses.reduce((accumulator, course) => {
            let commonEarnedForCourse = coursesObject[course].reduce((accumulateEarnedForCourse, courseBlock) => {
              accumulateEarnedForCourse += courseBlock.earned_all

              return accumulateEarnedForCourse
            }, 0)

            let commonPossibleForCourse = coursesObject[course].reduce((accumulatePossibleForCourse, courseBlock) => {
              accumulatePossibleForCourse += courseBlock.possible_all

              return accumulatePossibleForCourse
            }, 0)

            accumulator += parseInt(commonEarnedForCourse / commonPossibleForCourse * 100)

            return accumulator
          }, 0)

          result = parseInt(coursesCommonPercents / courses.length)
        }

        return result
      }
    },
    filters: {
      filterRoleNames (val) {
        return val.map(mapping => mapping.name).join()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Users.vue?2ed53c3a